module.exports = __webpack_public_path__ + "791b7233019ee3e953d5625959448273.svg";